@if (newPrinterFormService.printerFormReady() && newPrinterGroupForm) {
    <app-main-base [useGrid]="true"
        [fullHeight]="false"
        [isMobile]="isMobile"
        (back)="goBack()">
        
        <div mainTitle class="tw-w-full tw-min-w-0">
            <span class="tw-w-full" [appTruncatedText]="titlePage || ''"
            >{{ titlePage }}</span>
        </div>
    
        <ng-container mainActions>
            <app-action-btn (click)="cancel()"
                variant="basic">
                Annulla
            </app-action-btn>
            <app-action-btn (click)="save()"
                [disabled]="!newPrinterFormService.form.valid || !newPrinterFormService.type?.value || !!(newPrinterFormService.name?.disabled)">
                Salva
            </app-action-btn>
        </ng-container>
    
        <div mainBody class="tw-contents">
            @if(!isMobile && !isSmallDisplay()) {
                <div class="tw-flex tw-flex-col tw-gap-4 tw-h-full">
                    <ng-container *ngTemplateOutlet="typeCard"></ng-container>
    
                    @if(connectionCardOnRigth) {
                        <ng-container *ngTemplateOutlet="documentsCard"></ng-container>
                    }
    
                    @if(!connectionCardOnRigth) {
                        <ng-container *ngTemplateOutlet="connectionCard"></ng-container>
                    }
                </div>
    
                <div class="tw-flex tw-flex-col tw-gap-4 tw-h-full">
                    <ng-container *ngTemplateOutlet="manifacturerCard"></ng-container>
    
                    @if(!connectionCardOnRigth) {
                        <ng-container *ngTemplateOutlet="documentsCard"></ng-container>
                    }
    
                    @if(connectionCardOnRigth) {
                        <ng-container *ngTemplateOutlet="connectionCard"></ng-container>
                    }
                </div>
            } @else {
                <ng-container *ngTemplateOutlet="typeCard"></ng-container>
                <ng-container *ngTemplateOutlet="manifacturerCard"></ng-container>
                <ng-container *ngTemplateOutlet="connectionCard"></ng-container>
                <ng-container *ngTemplateOutlet="documentsCard"></ng-container>
            }
        </div>
    </app-main-base>
}

<ng-template #typeCard>
    <app-card
        [fullWidth]="false"
        [withCard]="true"
        [cardTitle]="'PRINTERS.DETAIL.TYPE' | translate"
    >
        <form autocomplete="off" [formGroup]="newPrinterGroupForm"
                class="tw-contents">
            <section class="tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-5 tw-p-1 tw-items-center">

                <div class="tw-flex tw-flex-col tw-col-span-12">
                    <!-- <mat-label [class]="subTitleClass" class="tw-px-2 tw-mb-2"
                        translate>PRINTERS.NEW_DIALOG.TYPE</mat-label> -->
                    <mat-radio-group formControlName="type"
                        class="tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-3 tw-items-center"
                        (change)="onChangePrinterType($event)">
                        @for(type of printerTypesList; track type.value) {
                            <mat-radio-button color="primary" [value]="type.value"
                                class="tw-col-span-12 md:tw-col-span-6"
                                [class]="(type.value === newPrinterFormService.type?.value) ? linearValueClass: ''">
                                {{ type.name | translate }}</mat-radio-button>
                        }
                    </mat-radio-group>
                </div>
            </section>
        </form>
    </app-card>
</ng-template>

<ng-template #manifacturerCard>
    @if(isFiscalOrRT() && vendorsList) {
        <app-card
            [fullWidth]="false"
            [withCard]="true"
            [cardTitle]="'PRINTERS.DETAIL.MANIFACTURER' | translate"
        >
            <form autocomplete="off" [formGroup]="newPrinterGroupForm"
                    class="tw-contents">
                <section class="tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-5 tw-p-1 tw-items-center">
                    <div class="tw-flex tw-flex-col tw-col-span-12">
                        <!-- <mat-label [class]="subTitleClass" class="tw-px-2 tw-mb-2">{{ 'PRINTERS.NEW_DIALOG.MANIFACTURER' | translate }}</mat-label> -->
                        <mat-radio-group formControlName="manifacturer"
                            class="tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-3 tw-items-center"
                            (change)="onChangeManifacturer()">
                            @for(vendor of vendorsList; track vendor.value) {
                                <mat-radio-button color="primary" [value]="vendor.value"
                                    class="tw-col-span-12 md:tw-col-span-6"
                                    [class]="(vendor.value === newPrinterFormService.manifacturer?.value) ? linearValueClass: ''"
                                    >{{ vendor.name | translate }}</mat-radio-button>
                            }
                        </mat-radio-group>
                    </div>
                </section>
            </form>
        </app-card>
    }
</ng-template>

<ng-template #connectionCard>
    @if(newPrinterFormService.type?.value) {
        <app-card
            [fullWidth]="false"
            [withCard]="true"
            [cardTitle]="'PRINTERS.DETAIL.CONNECTION' | translate"
        >
            <form autocomplete="off" [formGroup]="newPrinterGroupForm"
                    class="tw-contents">
                <section class="tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-5 tw-p-1 tw-items-center">
                    <mat-form-field class="tw-col-span-12">
                        <mat-label translate>PRINTERS.DETAIL.NAME</mat-label>
                        <input matInput formControlName="name" appTrimInput>
                        <mat-hint [align]="'end'">{{newPrinterFormService.name?.value?.length || '0'}}
                            / {{newPrinterFormService.validators.nameMaxLength}}</mat-hint>
                        @if(newPrinterFormService.name?.hasError('maxlength')) {
                            <mat-error>{{'NG_MESSAGES.NAME_TOO_LONG' | translate}} (max. {{newPrinterFormService.validators.nameMaxLength}})</mat-error>
                        } @else if(newPrinterFormService.name?.hasError('minlength')) {
                            <mat-error>{{'NG_MESSAGES.NAME_TOO_SHORT' | translate}} (max. {{newPrinterFormService.validators.nameMinLength}})</mat-error>
                        } @else if(newPrinterFormService.name?.hasError('required')) {
                            <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                        }
                    </mat-form-field>

                    <mat-form-field class="tw-col-span-12">
                        <mat-label translate>PRINTERS.DETAIL.IP</mat-label>
                        <input matInput formControlName="ip_address" appTrimInput>
                        <mat-hint [align]="'end'">{{newPrinterFormService.ipAddress?.value?.length || '0'}}
                            / {{newPrinterFormService.validators.ipAddressMaxLength}}</mat-hint>
                        @if(newPrinterFormService.ipAddress?.hasError('maxlength')) {
                            <mat-error>{{'NG_MESSAGES.NAME_TOO_LONG' | translate}} (max. {{newPrinterFormService.validators.ipAddressMaxLength}})</mat-error>
                        } @else if(newPrinterFormService.ipAddress?.hasError('required')) {
                            <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                        }
                    </mat-form-field>

                    @if(newPrinterFormService.driver?.value === 'escpos' || newPrinterFormService.driver?.value === 'epos') {
                        <div class="tw-flex tw-flex-col tw-col-span-12">
                            <mat-label [class]="subTitleClass" class="tw-px-2 tw-mb-2"
                                translate>PRINTERS.NEW.CONNECTION_TYPE</mat-label>
                            <mat-radio-group formControlName="driver"
                                class="tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-3 tw-items-center">
                                @for(type of connectionTypesList; track type.value) {
                                    <mat-radio-button color="primary" [value]="type.value"
                                        class="tw-col-span-12 md:tw-col-span-6"
                                        [class]="(type.value === newPrinterFormService.driver?.value) ? linearValueClass: ''"
                                        >{{ type.name | translate }}</mat-radio-button>
                                }
                            </mat-radio-group>
                        </div>
                    }

                </section>
            </form>
        </app-card>
        
        @if(newPrinterFormService.type?.value === 'receipt') {
            <app-card
                [fullWidth]="false"
                [halfHeigth]="!isSmallDisplay()"
                [withCard]="true"
                [cardTitle]="'PRINTERS.DETAIL.PROVIDER' | translate"
            >
                <form autocomplete="off" [formGroup]="newPrinterGroupForm"
                        class="tw-contents">
                    <section class="tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-5 tw-p-1 tw-items-center">
                        <mat-form-field class="tw-col-span-12">
                            <mat-label translate>PRINTERS.NEW.FISCAL_PROVIDER</mat-label>
                            <mat-select formControlName="fiscal_provider">
                                @for(provider of fiscalProvidersList; track provider.value) {
                                    <mat-option [value]="provider.value">{{provider.name | translate}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </section>
                </form>
            </app-card>
        }
    }
</ng-template>

<ng-template #documentsCard>
    @if(availableDocs?.length) {
        <app-card 
            [fullWidth]="false"
            [withCard]="true"
            [cardTitle]="'PRINTERS.DETAIL.DOCUMENTS' | translate"
        >
        <!-- @if(newPrinterGroupForm.hasError('atLeastOneTrue')) {
            <mat-error class="tw-px-3 tw-pb-1">Selezionare almeno un documento</mat-error>
        } -->
        <div class="tw-px-3 tw-pb-1" [class]="subTitleClass">
            Selezionare almeno un documento
        </div>
        <form autocomplete="off" [formGroup]="newPrinterGroupForm"
                class="tw-contents">
            <section class="tw-grid tw-grid-cols-1 tw-gap-3">
                @for(doc of availableDocs; track doc.id; let i = $index) {
                    <!-- <mat-checkbox [formControlName]="doc.check" class="tw-p-1">
                        <span>{{ doc.name }}</span>
                    </mat-checkbox> -->

                    <mat-slide-toggle [formControlName]="doc.check" class="tw-flex tw-p-3">
                        <span class="tw-flex tw-ml-2">{{ doc.name }}</span>
                    </mat-slide-toggle>
                }
            </section>
        </form>
        </app-card>
    }
</ng-template>